<template>
  <div id="app">
    <MainComponent/>
    <!--<div class="flex justify-center text-xl">
      <div class="flex justify-center text-center">Menümüz güncelleniyor, lütfen çalışma arkadaşlarımıza danışın...</div>
    </div>-->
    <div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
      <img src="../src/assets/1.jpg" alt="menu cover">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/2.jpg" alt="menu page 2">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/3.jpg" alt="menu page 3">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/4.jpg" alt="menu page 4">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/5.jpg" alt="menu page 5">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/6.jpg" alt="menu page 6">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/7.jpg" alt="menu page 7">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/8.jpg" alt="menu page 8">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/9.jpg" alt="menu page 9">
      </div>
      <div class="lg:flex xl:flex justify-center owerflow-hidden p-8">
        <img src="../src/assets/10.jpg" alt="menu page 10">
      </div>
    </div>
  </div>
</template>

<script>
import MainComponent from './components/mainComponent.vue'
export default {
  name: 'App',
  data () {
    return {
      menuStatus: 0,
    }
  },
  components: {
    MainComponent
  }
  /*async created() {
    var { data }=await axios.get("https://recruitment-mock-data.gjg-ads.io/data") ;
    console.log(data)
  }*/
}
</script>

<style>

</style>
